import React , { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../redux/actions/ContentActions";
import { useNavigate, Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { Helmet } from 'react-helmet';

import Header from "../components/Header";
import Footer from "../components/Footer";
import { APP_SERVER_BASE_URL } from '../config/config';
import SharePage from "../components/SharePage";
import pdfIcon from "../assets/images/pdf_icon.png";
import imgIcon from "../assets/images/img_icon.png";

interface ContentDetails {
  id?: number;
  title?: string;
  short_description?:string;
  description?: string;
  updated_at?: Date;
  image?:string;
  // add any other expected fields
}

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const Details: React.FC = () => {


    const dispatch = useDispatch<any>();
    const [data_content, setDataContent] = useState<ContentDetails>({});
    const [related_content, setRelatedContent] = useState<ContentDetails>({});
     const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
    const { slug } = useParams<{ slug: string }>();
    const { content } = useParams<{ content: string }>();
    const [images, setImages] = useState<any[]>([]);
    const [pdfs, setPdfs] = useState<any[]>([]);
    const data = useSelector((state: any) => state.content_details.content_data || {});
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isPaymentPaid, setIsPaymentPaid] = useState(false);


    useEffect(() => {
        setDataContent(data?.data)
        setRelatedContent(data?.related);
        setSoeContent({meta_title:data?.data?.meta_title,meta_description:data?.data?.meta_description})
        setIsPaymentPaid(data?.is_payment_paid);

        // ✅ Filter content_media by mimetype
        const images = data?.data?.content_media
        ?.filter((media: any) => media.mimetype?.startsWith("image/"))
        .map((media: any) => media);

        const pdfs = data?.data?.content_media
        ?.filter((media: any) => media.mimetype === "application/pdf")
        .map((media: any) => media);

        console.log("images : ",images ,"pdfs : ",pdfs)

        // ✅ Prepopulate existing images & PDFs
        setImages(images || []);
        setPdfs(pdfs || []);

        console.log(JSON.stringify(data?.data?.title))
        console.log(JSON.stringify(data?.related))
        console.log(JSON.stringify(data?.image))
    }, [dispatch,data]);

    useEffect(() => {
        dispatch(getData(slug,content))
    }, [slug,content]);



  return (
    <>
      <Helmet>
        <title>{`${soeContent?.meta_title || 'Explore Learning Resources'}`}</title>
        <meta name="title" content={soeContent?.meta_title || 'E-learning Platform - Explore Learning Resources'} />
        <meta name="description" content={soeContent?.meta_description || 'Access detailed, high-quality tech learning content including tutorials, case studies, and more.'} />
        <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials, learning resources" />
      </Helmet>
      <Header />
      {/* Hero */}
      <section className="text-white py-5" style={{ background: "linear-gradient(to right, #2563eb, #4f46e5)" }}>
        <div className="container">
          <h1 className="display-5 fw-bold">{data_content?.title}</h1>
          <p className="lead">{data_content?.short_description}</p>
          <div className="row justify-content-end"> 
            <div className="col-lg-3  mb-4">
              <SharePage title={data_content?.title || ""}/>
            </div>
          </div>
        </div>
      </section>

      {/* Page Content */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar (Table of Contents) */}
            <aside className="col-lg-3 mb-4 order-2 order-lg-1">
              <div className="bg-light p-4 rounded shadow-sm border sticky-top" style={{ top: "100px" }}>
                <h6 className="fw-bold text-primary mb-3">
                  <i className="fas fa-list-alt me-2"></i>Related Content
                </h6>
                <ul className="list-group list-group-flush small">
                  {Array.isArray(related_content) && related_content.length > 0 ? (
                    related_content.map((course: any, key: number) => (
                      <li key={key} className="list-group-item px-0 py-2 border-0">
                        <Link 
                          to={`/${slug}/${course.slug}`} 
                          className="text-decoration-none d-flex align-items-start gap-2"
                        >
                          <span className="badge bg-primary rounded-circle" style={{ width: '22px', height: '22px' ,paddingTop:'5px'}}>
                            {key + 1}
                          </span>
                          <span>{course?.title}</span>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="text-muted">No related data found.</li>
                  )}
                </ul>
              </div>
            </aside>

            {/* Main Content */}
            <article className="col-lg-9 order-1 order-lg-2">
              <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(data_content?.description || ""),
                  }}
                />
-
                {/* New Images */}
                {images?.length > 0 && (
                  <div className="mt-3">
                    {/* Heading */}
                    <h6 className="fw-bold text-primary mb-3">
                      Artifacts Image's
                    </h6>
                    {/* Images Grid */}
                    <div className="d-flex flex-wrap gap-3">
                      {images.map((file: any, idx: number) => (
                        <div
                          key={`new-${idx}`}
                          className="p-2 border rounded d-flex align-items-center justify-content-center"
                          style={{ width: "150px",height: "150px",overflow: "hidden",cursor: "pointer" }}
                          onClick={() => setSelectedImage((isPaymentPaid)?APP_SERVER_BASE_URL + "/" + file?.path:imgIcon)}
                        >
                          <img
                            src={(isPaymentPaid)?APP_SERVER_BASE_URL + "/" + file?.path:imgIcon}
                            alt="Current"
                            style={{width: "100%",height: "100%",objectFit: "cover",borderRadius: "4px"}}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Popup Modal */}
                {selectedImage && (
                  <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.7)",
                      zIndex: 1050,
                    }}
                  >
                    <div className="position-relative">
                      <button
                        className="btn btn-light position-absolute"
                        style={{ top: "-40px", right: "0" }}
                        onClick={() => setSelectedImage(null)}
                      >
                        ✕
                      </button>
                      <img
                        src={selectedImage}
                        alt="Full View"
                        style={{
                          maxWidth: "90vw",
                          maxHeight: "80vh",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* New PDFs */}
                {pdfs?.length > 0 && (
                  <div className="mt-3">
                    {/* Heading */}
                    <h6 className="fw-bold text-primary mb-3">
                      Artifacts PDF's
                    </h6>
                    {/* PDF Grid */}
                    <div className="d-flex flex-wrap gap-3">
                      {pdfs.map((file: any, idx: number) => (
                        <div
                          key={`pdf-${idx}`}
                          className="p-2 border rounded d-flex align-items-center justify-content-center"
                          style={{ width: "150px",height: "150px",overflow: "hidden", cursor: "pointer"}}
                          onClick={() => (isPaymentPaid)?window.open(APP_SERVER_BASE_URL + "/" + file?.path, "_blank"):"" }
                        >
                          <img
                            src={pdfIcon}
                            alt="PDF Icon"
                            style={{width: "60%", height: "auto",objectFit: "contain"}}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}



            </article>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Details;
